export const MONSTER_QUIZ_TEXT = 'Monster Quiz'
export const SHOUT_IT_OUT_TEXT = 'Shout It Out'
export const RESPONSE_2_TEXT = 'Response 2'
export const SUPER_SORT_TEXT = 'Super Sort'
export const LABEL_REVEAL_TEXT = 'Label Reveal'
export const MATCH_EM_UP_TEXT = 'Match Em Up!'
export const SPEED_UP_TEXT = 'Speedup'
export const FILL_IN_THE_BLANKS_TEXT = 'Fill in the Blanks'
export const FLIP_OUT_TEXT = 'Flip Out'
export const GAME_SHOW_TEXT = 'Game Show'
export const RANK_ORDER_TEXT = 'Rank Order'
export const MEMORY_WATCH_TEXT = 'Memory Watch'

export const MONSTER_QUIZ_TYPE = 'teamquiz'
export const SHOUT_IT_OUT_TYPE = 'shout-it-out'
export const RESPONSE_2_TYPE = 'assessment'
export const SUPER_SORT_TYPE = 'dropzone'
export const LABEL_REVEAL_TYPE = 'label-reveal'
export const MATCH_EM_UP_TYPE = 'matching'
export const SPEED_UP_TYPE = 'speedup'
export const FILL_IN_THE_BLANKS_TYPE = 'fillintheblanks'
export const FLIP_OUT_TYPE = 'flipcard'
export const GAME_SHOW_TYPE = 'gameshow'
export const RANK_ORDER_TYPE = 'ranking'
export const MEMORY_WATCH_TYPE = 'memory'
